import { useEffect, useState, useRef } from "react";
import {
  collection, getDocs, doc, updateDoc, addDoc, deleteDoc,
  query, orderBy
} from "firebase/firestore";
import { db, storage } from "./firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./index.css";

function PatrocinadoresOutros() {
  const [patrocinadores, setPatrocinadores] = useState([]);
  const [erro, setErro] = useState("");
  const [selecionado, setSelecionado] = useState(null);
  const [pesquisa, setPesquisa] = useState("");
  const [novo, setNovo] = useState({ nome: "", site: "", logo: "" });
  const [logoPreview, setLogoPreview] = useState(null);
  const fileRef = useRef(null);

  const fetchPatrocinadores = async () => {
    try {
      const q = query(collection(db, "evento_patrocinadores_outros"), orderBy("nome", "asc"));
      const snapshot = await getDocs(q);
      setPatrocinadores(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error(err);
      setErro("Erro ao carregar os patrocinadores.");
    }
  };

  useEffect(() => {
    fetchPatrocinadores();
  }, []);

  useEffect(() => {
    if (!novo.logo) {
      setLogoPreview(null);
      return;
    }
    if (typeof novo.logo === "string") {
      setLogoPreview(novo.logo);
    } else {
      const url = URL.createObjectURL(novo.logo);
      setLogoPreview(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [novo.logo]);

  const salvarCampo = async (id, campo, valor) => {
    const docRef = doc(db, "evento_patrocinadores_outros", id);
    await updateDoc(docRef, { [campo]: valor });
  };

  const salvarLogo = async (id) => {
    if (!novo.logo || typeof novo.logo === "string") return null;
    const logoRef = ref(storage, `patrocinadores/${novo.logo.name}`);
    await uploadBytes(logoRef, novo.logo);
    const url = await getDownloadURL(logoRef);
    await salvarCampo(id, "logo", url);
    return url;
  };

  const deletarPatrocinador = async (id) => {
    if (!window.confirm("Tem certeza de que deseja excluir este patrocinador da app?")) return;
    try {
      await deleteDoc(doc(db, "evento_patrocinadores_outros", id));
      setPatrocinadores(prev => prev.filter(p => p.id !== id));
      if (selecionado?.id === id) setSelecionado(null);
    } catch (err) {
      console.error(err);
      alert("Erro ao apagar.");
    }
  };

  const salvarTudo = async () => {
    if (!novo.nome.trim()) { alert("O campo 'Nome' é obrigatório."); return; }

    try {
      let id = selecionado?.id ?? null;
      let logoURL = selecionado?.logo || "";

      if (!id) {
        const novoDoc = { nome: novo.nome, site: novo.site, logo: "" };
        const docRef = await addDoc(collection(db, "evento_patrocinadores_outros"), novoDoc);
        id = docRef.id;
      } else {
        await salvarCampo(id, "nome", novo.nome);
        await salvarCampo(id, "site", novo.site);
      }

      if (novo.logo) {
        const url = await salvarLogo(id);
        if (url) logoURL = url;
      }

      await fetchPatrocinadores();
      setSelecionado(null);
      setNovo({ nome: "", site: "", logo: "" });
      setLogoPreview(null);
    } catch (err) {
      console.error("Erro ao guardar:", err);
      alert("Erro ao guardar os dados.");
    }
  };

  const exportarCSV = () => {
    const headers = ["nome", "site", "logo"];
    const rows = patrocinadores.length
      ? patrocinadores.map(d => headers.map(h => d[h] || ""))
      : [["", "", ""]];
    const csv = [headers, ...rows].map(r => r.map(v => `"${v}"`).join(";")).join("\n");
    const bom = "\uFEFF";
    const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "patrocinadores_outros.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // CORREÇÃO: detetar TAB além de ; e ,
  const detectSeparator = (line) => {
    if (line.includes(";")) return ";";
    if (line.includes(",")) return ",";
    if (line.includes("\t")) return "\t";
    return ","; // fallback
  };

  const handleImportarCSV = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    alert("A sua importação está em processamento. Por favor, aguarde...");

    try {
      const text = await file.text();
      const lines = text.split("\n").map(l => l.trim()).filter(Boolean);
      if (lines.length < 2) {
        alert("O ficheiro CSV está vazio ou incorreto.");
        e.target.value = null;
        return;
      }

      const sep = detectSeparator(lines[0]);
      const headers = lines[0].split(sep).map(h => h.replace(/"/g, "").trim());

      if (!headers.includes("nome")) {
        alert("O CSV tem de conter a coluna 'nome'.");
        e.target.value = null;
        return;
      }

      const existentes = new Set(patrocinadores.map(p => (p.nome || "").toLowerCase().trim()));
      const duplicados = [];
      let adicionados = 0;

      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(sep).map(v => v.replace(/"/g, "").trim());
        const obj = {};
        headers.forEach((h, j) => { obj[h] = values[j] || ""; });

        const nomeLower = (obj.nome || "").toLowerCase().trim();
        if (!nomeLower) continue;

        if (existentes.has(nomeLower)) {
          duplicados.push(i + 1);
          continue;
        }

        await addDoc(collection(db, "evento_patrocinadores_outros"), obj);
        existentes.add(nomeLower);
        adicionados++;
      }

      await fetchPatrocinadores();

      if (duplicados.length > 0 && adicionados === 0) {
        alert("Todos os dados já estão inseridos na tabela.");
      } else if (duplicados.length > 0) {
        alert(`Importação concluída parcialmente.\n${adicionados} adicionados.\nLinhas duplicadas ignoradas: ${duplicados.join(", ")}`);
      } else {
        alert(`Importação concluída com sucesso! ${adicionados} patrocinadores adicionados.`);
      }
    } catch (err) {
      console.error(err);
      alert("Erro ao importar o ficheiro CSV.");
    }

    e.target.value = null;
  };

  const patrocinadoresFiltrados = patrocinadores
    .filter(p => p.nome?.toLowerCase().includes(pesquisa.toLowerCase()))
    .sort((a, b) => a.nome.localeCompare(b.nome));

  if (erro) return <p>{erro}</p>;

  return (
    <div className="table-container">
      <div>
        <input
          type="text"
          placeholder="Procurar por nome"
          value={pesquisa}
          onChange={e => setPesquisa(e.target.value)}
          className="input"
        />

        <button className="btn btn-other" onClick={exportarCSV}>Exportar CSV</button>

        <label className="btn btn-other" style={{ cursor: "pointer" }}>
          Importar CSV
          <input type="file" accept=".csv" style={{ display: "none" }} onChange={handleImportarCSV} />
        </label>
      </div>

      {patrocinadoresFiltrados.length === 0 ? (
        <p style={{ textAlign: "center", color: "#292f2c" }}>Sem dados</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Logo</th>
              <th>Nome</th>
              <th>Site</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {patrocinadoresFiltrados.map(p => (
              <tr key={p.id}>
                <td>{p.logo ? <img src={p.logo} alt="Logo" style={{ width: 50, height: 50, objectFit: "contain" }} /> : "—"}</td>
                <td>{p.nome || "—"}</td>
                <td>{p.site || "—"}</td>
                <td>
                  <button
                    className="btn btn-add"
                    onClick={() => {
                      setSelecionado(p);
                      setNovo({ nome: p.nome, site: p.site, logo: p.logo || "" });
                      setLogoPreview(p.logo || null);
                    }}
                  >
                    Editar
                  </button>

                  <button className="btn btn-delete" onClick={() => deletarPatrocinador(p.id)}>
                    Apagar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {selecionado && (
        <div className="drawer">
          <div className="drawer-content">
            <label>Nome:</label>
            <input
              type="text"
              value={novo.nome}
              onChange={e => setNovo(prev => ({ ...prev, nome: e.target.value }))}
            />

            <br /><br />
            <label>Site:</label>
            <input
              type="text"
              value={novo.site}
              onChange={e => setNovo(prev => ({ ...prev, site: e.target.value }))}
            />

            <br /><br />
            <label>Logo:</label>
            <div>
              {(logoPreview || selecionado.logo) && (
                <img
                  src={logoPreview || selecionado.logo}
                  alt="Logo"
                  style={{ width: 100, height: 100, objectFit: "contain" }}
                />
              )}
            </div>

            <input
              type="file"
              ref={fileRef}
              onChange={e => {
                const file = e.target.files[0];
                setNovo(prev => ({ ...prev, logo: file }));
                setLogoPreview(file ? URL.createObjectURL(file) : null);
              }}
            />
          </div>

          <div className="drawer-footer">
            <button className="btn btn-add" onClick={salvarTudo}>Guardar</button>
            <button className="btn btn-cancel" onClick={() => setSelecionado(null)}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PatrocinadoresOutros;
